import { Observable } from 'rxjs/Observable';
import { Vet } from './../_models/vet';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';

@Injectable()
export class VetsService {

  private vetsCollection: AngularFirestoreCollection<Vet>;

  constructor(
    private _firestore: AngularFirestore
  ) {
  }

  /**
   *
   */
  getVets(): Observable<Vet[]> {

    this.vetsCollection = this._firestore.collection<Vet>('vets', ref =>
      ref
        .orderBy('name', 'asc')
    );

    return this.vetsCollection.snapshotChanges().map(o => {
      return o.map(item => {
        const data = item.payload.doc.data();
        const uuid = item.payload.doc.id;

        if (data.birthday) {
          if (typeof data.birthday.toDate === 'function') {
            data.birthday = data.birthday.toDate();
          }
        }

        if (data.date) {
          if (typeof data.date.toDate === 'function') {
            data.date = data.date.toDate();
          }
        }

        return new Vet({ ...{ uuid: uuid }, ...data });
      });
    });

  }

  /**
   *
   * @param uuid
   */
  getVet(uuid: string) {
    return this._firestore.doc<Vet>('vets/' + uuid);
  }

  /**
   * Inserir um novo veterinário no sistema
   * @param vet parâmetro de veterinário
   */
  insertVet(vet: Vet) {
    return this._firestore
      .collection('vets')
      .add(vet.toFirebase());
  }

  deleteVet(vet: Vet) {
    return this._firestore.doc(`vets/${vet.uuid}`).delete();
  }

  /**
   * Atualizar veterinário no sistema
   * @param vet parâmetro de veterinário
   */
  updateVet(vet: Vet, uuid: any) {

    return this._firestore
      .collection('vets')
      .doc(uuid)
      .update(vet.toFirebase());
  }
}
